<template lang="pug">

  span

    p Neste instrumento as palavras grafadas com letras maiúsculas terão o significado que a elas é soto-estabelecido:

    p
      strong SITE:
      span &nbsp;conjunto de páginas da Internet ocupado com conteúdo de empresas ou mesmo de pessoas.

    p
      strong SOS PLANTÃO:
      span &nbsp;é o SITE registrado sob o domínio https://www.sosplantao.com/site/, bem como todos os sub domínios, recursos e ferramentas relacionados a este.

    p
      strong USUÁRIO(S):
      span &nbsp;são as pessoas físicas ou jurídicas que acessam e usam os serviços providos pelo SOS PLANTÃO.

    p
      strong ANUNCIANTE(S):
      span &nbsp;é um tipo de USUÁRIO do SOS PLANTÃO que compõe pessoas jurídicas, órgãos e associações. São USUÁRIO(S) que não se enquadram como pessoa física, ou seja, que não são profissionais plantonistas.

    ol

      li

        h5 Aceitação dos termos:

        p O prosseguimento no cadastro e/ou mesmo a continuidade do uso do SOS PLANTÃO implica automaticamente na aceitação de todos os termos aqui descritos.
        p Se o USUÁRIO não concorda com algum item aqui descrito deve primeiramente solicitar a revisão/alteração ou então está automaticamente inapto a utilizar o serviço.

      li

        h5 Linhas gerais:

        p Este SITE, SOS PLANTÃO, está estabelecido no domínio sosplantao.com na rede mundial de computadores, internet. O objetivo é facilitar o encontro de profissionais de uma mesma classe para a troca de escalas de serviços (plantões), anúncios e busca de empregos e demais interações, principalmente profissional. O SOS PLANTÃO é apenas um facilitador, funcionando como um anúncio de classificados.
        p O SOS PLANTÃO apenas fornece os contatos e assim se exime de qualquer obrigação ou responsabilidade das interações dos USUÁRIO(S) : dados fornecidos, capacidade profissional de cada indivíduo, obrigações com o orgão da respectiva classe, não comparecimento, não pagamento e demais atribuições que são de completa responsabilidade entre os USUÁRIO(S) que fizerem as transações.
        p O SOS PLANTÃO se destina a profissionais devidamente capacitados a trabalhar e, se for o caso, em dia com seus respectivos conselhos (CRM, COREN, etc.), orgãos de classe, associações, etc.
        p Entidades de Saúde(Hospitais, Cooperativas, etc) podem aderir ao SOS PLANTÃO como ANUNCIANTE e assim interagir com os USUÁRIO(S) que são profissionais.

      li

        h5 Direitos e deveres conferidos ao SOS PLANTÃO:

        p O SOS PLANTÃO poderá, a qualquer momento e a seu exclusivo critério, modificar a configuração de seu SITE. Poderá também eliminar ou acrescentar quaisquer itens em seu banco de dados, adicionar ou retirar funcionalidades bem como alterar os regulamentos e contratos disponibilizados para os USUÁRIO(S).
        p O SOS PLANTÃO poderá, a qualquer momento e a seu exclusivo critério, suspender e/ou bloquear um USUÁRIO, por qualquer motivo entendido pelos seus administradores, sem a necessidade de aviso prévio e nem mesmo explicação sobre a suspensão ou bloqueio.
        p O SOS PLANTÃO se compromete a, dentro das possibilidades, corrigir da melhor maneira e o mais rápido possível eventuais erros diagnosticados no funcionamento de seu SITE.
        p O SOS PLANTÃO não se responsabiliza por danos e/ou prejuízos decorrentes da indisponibilidade ou mesmo por erros de funcionamento do próprio SITE.
        p(v-html="linha1")
        p É de interesse do SOS PLANTÃO sempre reforçar a segurança do acesso ao SITE, todavia o SOS PLANTÃO fica eximido de qualquer responsabilidade por danos ou problemas oriundos de acessos não autorizados de terceiros a áreas restritas do SITE.
        p O SOS PLANTÃO se compromete a sempre buscar melhorias, por vezes o SITE poderá ficar inacessível, mas sempre buscando um bem maior.
        p(v-html="linha2")
        p As sanções de acesso aplicadas aos USUÁRIO(S) são de decisão única e exclusiva dos administradores do SOS PLANTÃO, esta poderá ser desde uma suspensão temporária de acesso ao sistema ou até mesmo o bloqueio definitivo do acesso ao SOS PLANTÃO.
        p O SOS PLANTÃO poderá, a qualquer momento e a seu exclusivo critério, começar a cobrar por seus serviços prestados. Essa cobrança poderá ser feita do modo que os administradores entenderem e não caberá aos USUÁRIO(S) nenhum tipo de contestação, podendo o USUÁRIO, livremente deixar de utilizar os serviços.
        p O não pagamento de uma cobrança implica na automática restrição de acesso a qual se refere essa cobrança. Não cabe ao SOS PLANTÃO, nesse caso, qualquer ressarcimento e ao USUÁRIO será aplicada a restrição relativa a devida cobrança.

      li

        h4 Direitos e deveres dos USUÁRIO(S) do SOS PLANTÃO:

        ol

          li

            h5 Aplicações a todos os tipos de USUÁRIO(S) que fazem uso do SOS PLANTÃO:

            p
              | Cada USUÁRIO será detentor de um nome de usuário (login) e senha para acesso à sua área restrita no SOS PLANTÃO, assumindo a devida responsabilidade sobre o sigilo da senha e a sua segurança de acesso.
              | Após efetuarem a compra, troca ou venda de plantões, os USUÁRIO(S) poderão dar e receber avaliações. As avaliações servem para que profissionais com boa conduta no processo sejam evidenciados em futuras transações e os de má conduta devidamente marcados.
              | *O SOS PLANTÃO não se responsabiliza pela avaliação dada ou recebida por nenhum USUÁRIO.

            p Fica sob responsabilidade de cada USUÁRIO as informações fornecidas ao SOS PLANTÃO e a respectiva veracidade, exatidão e autenticidade.

          li

            h5 No que se refere aos USUÁRIO(S) profissionais (pessoas físicas):

            p
              | Oferecemos os serviços de agenda, busca e troca de plantões para profissionais enquadrados nas categorias disponíveis no cadastro (Médico(a), Enfermeiro(a), etc.).
              | Cada pessoa física pertence a uma categoria profissional. Esta pessoa poderá interagir SOMENTE com pessoas físicas da mesma categoria (Médico(a), Enfermeiro(a), etc.), ou interagir com pessoas jurídicas se assim for permitido.
              | *O SOS PLANTÃO se reserva o direito de adicionar ou retirar qualquer categoria sem aviso prévio.

            p
              | Cada elemento dessa categoria poderá criar ofertas de emprego, anunciar e se candidatar aos turnos de serviços (plantões) para venda ou troca, mas sempre dentro da sua classe profissional.
              | Poderá ser viabilizado o uso dos serviços por outras classes ou entidades não disponíveis no cadastro. Nesse caso, normas e regras específicas poderão ser pré-estabelecidas, se for o caso.
              | Para algumas classes de profissionais poderá ser exigido o registro de classe profissional. Se exigido o registro profissional, APENAS 1(UM) USUÁRIO poderá se registrar a partir desta identificação profissional. Representantes da lei serão devidamente notificados em caso de uso da identificação profissional de um terceiro. Se o USUÁRIO possuir o registro em mais de um estado, então deverá utilizar aquele registro ativo e que mais utiliza.

          li

            h5 No que tange aos ANUNCIANTE(S):

            p
              | As áreas de acesso e ações disponíveis para cada ANUNCIANTE será devidamente acordado conforme o caso: Clínicas, Hospitais, órgãos governamentais, associações, sindicatos, etc.
              | Em geral, ANUNCIANTE(S) poderão criar ofertas de plantões, para diferentes classes profissionais, mas apenas para vender esses turnos de serviços, nunca se candidatar para algum.
              | Em geral, ANUNCIANTE(S) poderão oferecer vagas de emprego para diferentes classes profissionais.

      li

        h4 Sobre as informações e privacidade no SOS PLANTÃO:

        p
          | O SOS PLANTÃO se compromete a tomar as medidas possíveis para manter a confidencialidade dos dados de cada USUÁRIO, todavia o SOS PLANTÃO não se responsabiliza pela ação de pessoas que possam subverter essa segurança e acessar as informações dos USUÁRIO(S) .
          | O SOS PLANTÃO fica expressamente autorizado pelo USUÁRIO a fazer uso de qualquer tipo de comunicação (avisos, relatórios, marketing, etc.) do próprio SITE ou mesmo de terceiros e se utilizando qualquer meio (e-mail, sms, telefonia móvel, mala direta, etc.).
          | Na área de pessoas físicas buscamos restringir o acesso somente a profissionais devidamente autorizados por seus respectivos conselhos, se existente.
          | Oferecemos a oportunidade de certificação de autenticidade no SOS PLANTÃO: 1 - O USUÁRIO envia fotocópia de uma cédula que confirme sua identidade e outra que confirme seu registro no conselho, se for o caso. 2 - O sistema exibe que esse USUÁRIO passou por esse processo de autenticação. 3 - Fica sob responsabilidade de cada USUÁRIO do SOS PLANTÃO interagir com USUÁRIO(S) devidamente autenticados ou não. *Fica claro que o processo de autenticação NÃO garante a autenticidade do USUÁRIO e de suas informações prestadas. Esse processo apenas busca dificultar a ação de mal intencionados que serão devidamente acionados civil e criminalmente.

        p Autoridades representantes da lei poderão, se necessário, ter acesso irrestrito às informações colocadas no SOS PLANTÃO a fim de coibir violações da lei ou da moral tais como: falsidade ideológica, injúria, difamação, etc.

      li

        h4 É expressamente VEDADO aos USUÁRIO(S):

        p *Qualquer infração abaixo está sujeita às sanções de acesso ao sistema ou mesmo denúncia às autoridades da lei e/ou ao orgão da classe competente.

        p
          | Fornecer dados e/ou informações não verídicas.
          | Acessar, ou mesmo tentar, áreas não permitidas ao seu tipo de USUÁRIO. Por exemplo: Acessar áreas de profissionais de outra categoria, área de anunciantes, áreas administrativas, áreas de USUÁRIO(S) pagantes, etc.
          | Permitir que terceiros acessem o SOS PLANTÃO utilizando o seu cadastro, ou seja, com o seu nome de usuário e senha, indiferente da situação do terceiro.
          | *Esse terceiro também poderá ser denunciado ao orgão da respectiva classe.

        p Explorar o SOS PLANTÃO com fins econômicos, cessão de acesso ou qualquer outra forma que não seja de seu uso próprio. Uso pessoal no caso do USUÁRIO pessoa física e uso da instituição no caso da pessoa jurídica, orgãos, associações, etc.

      li

        h4 O USUÁRIO está ciente de que:

        p
          | Deve completar o formulário cadastral fornecendo dados e informações verdadeiras e precisas, responsabilizando-se civil e criminalmente por sua veracidade, devendo atualizar os dados e informações sempre que houver alterações.
          | Leu e está de acordo com os termos e condições deste instrumento.
          | É de sua inteira responsabilidade a veracidade as informações colocadas no SOS PLANTÃO bem como direitos outorgados a outrem.

      li

        h4 Dos pagamentos e contratações de serviços

        p
          | Se o acesso ao SITE estiver sendo cobrado, após a conclusão do cadastro, será concedido a cada USUÁRIO um período de avaliação. Este período será definido por um limite de tempo de acesso grátis, uma quantidade de trocas de plantões, anúncios e/ou qualquer outra contagem que o SOS PLANTÃO julgar pertinente.
          | Após o fim do período de avaliação, o USUÁRIO poderá dar continuidade ao acesso no SOS PLANTÃO através do pagamento de algum plano disponível. A continuidade do acesso está condicionada a confirmação do pagamento.
          | O SOS PLANTÃO poderá, a qualquer momento e a seu exclusivo critério, começar a cobrança pelo acesso a qualquer funcionalidade do SITE, alterar o modo de contagem do período de avaliação, planos, recursos e funcionalidades disponíveis nos planos e seus respectivos valores.

      li

        h4 Rescisão

        p
          | Este contrato pode ser rescindido a qualquer momento, por qualquer uma das partes, havendo ou não infração de quaisquer cláusulas, bastando para tanto a manifestação por escrito de uma parte à outra.
          | Fica estabelecido que ocorrendo a rescisão contratual, não haverá qualquer tipo de devolução de quantias pagas pelo USUÁRIO ao SOS PLANTÃO.
          | Havendo infração de qualquer cláusula deste termo de uso, o mesmo será automaticamente rescindido, independentemente de aviso ou comunicação entre as partes.
          | A rescisão deste contrato, motivada ou não, comunicada ou não, implicará ao USUÁRIO na perda automática do acesso as páginas e/ou serviços do SOS PLANTÃO pelo USUÁRIO.

      li

        h4 Lei e Jurisdição

        p O presente Termo de Condições de Uso é regido pela legislação da República Federativa do Brasil. Os usuários do site SOS PLANTÃO se submetem ao foro da Comarca de Campo Grande, capital do Estado de Mato Grosso do Sul, para dirimir quaisquer controvérsias, independente de qualquer outro foro, por mais privilegiado que seja.

</template>

<script>

  export default {
    name: 'TermsOfUse',

    data () {
      return {
        linha1: 'Este termo de uso poderá ser reformulado a qualquer momento e o seu devido teor estará disponível em <a href="https://www.sosplantao.com/site/" target="_blank">https://www.sosplantao.com/site/</a>',
        linha2: 'O SOS PLANTÃO também ficará disponível na área "fale conosco", em <a href="https://www.sosplantao.com/site/" target="_blank">https://www.sosplantao.com/site/</a>, <a href="https://www.sosplantao.com/site/perdas" target="_blank">https://www.sosplantao.com/site/perdas</a>, prejuízos ou danos, de nenhuma causa ou natureza, seja contratual ou não, seja ela resultante de qualquer tipo de interação no SITE.',
      }
    },
  }

</script>

<style lang="scss" scoped>

  a:hover {
    text-decoration: underline;
  }

</style>
